import {destroy, mutate, query, update} from "../../defaults/fetch";
import {useEffect, useState} from "react";


export const useCreatePayrollApproval = ()=>{
    return async (body) => {
        const url = `payroll-approval-stages/create`;
        const response = await mutate(url, true, body);
        return response.message;
    };
}


export const useFetchPayrollApprovalStages = (flag)=>{
    const [payrollApprovals,setPayrollApprovals] = useState([]);
    const [loading,setLoading] = useState(false);


    useEffect(()=>{
        const getAllPayrollApprovals = async ()=>{
            setLoading(true);
            const url = `payroll-approval-stages/get-all`
            const qs = {
                page:0,
                size:50
            };
            const {data} = await query(url,qs);
            setLoading(false);
            setPayrollApprovals(data)
        }
        getAllPayrollApprovals();
    },[flag]);

    return {loading,payrollApprovals};
}


export const useUpdatePayrollApprovalStage = ()=>{
    return async (id, body) => {
        const url = `payroll-approval-stages/update/${id}`;
        const {message} = await update(url, body);
        return message;
    };
}

export const useDeletePayrollApprovalStage = ()=>{
    return async (id) => {
        const url = `payroll-approval-stages/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    };
}
